import {
  MobileDatePickerProps,
  MobileDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

function DateInput(props: MobileDatePickerProps<Dayjs>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker format="DD/MM/YYYY" {...props} />
    </LocalizationProvider>
  );
}

export default DateInput;
